import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "application-form" }
const _hoisted_2 = {
  ref: "topForm",
  class: "popUpWindow register"
}
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { for: "address" }
const _hoisted_5 = { class: "application-form__horizontal" }
const _hoisted_6 = { class: "application-form__horizontal" }
const _hoisted_7 = { class: "cadastral-errors" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_10 = { class: "cadastral" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick", "onKeypress"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_trash icon trash_icon" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "addCadastralButtonContainer"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_plus" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  style: {"color":"red","margin-bottom":"20px"}
}
const _hoisted_19 = { class: "form-checkbox" }
const _hoisted_20 = { for: "location_information_extended" }
const _hoisted_21 = { class: "informationList" }
const _hoisted_22 = { class: "form-checkbox" }
const _hoisted_23 = { for: "location_information_basic" }
const _hoisted_24 = { class: "informationList" }
const _hoisted_25 = { class: "form-checkbox" }
const _hoisted_26 = { for: "information_of_intented_use_of_space" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "e-application-wrapper__card-footer" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)
const _hoisted_30 = { class: "fillDialogTitle" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 3 }
const _hoisted_35 = { key: 4 }
const _hoisted_36 = { class: "fillDialogButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputTextWrapper = _resolveComponent("InputTextWrapper")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FormCheckbox = _resolveComponent("FormCheckbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.name_and_surname`) + '*',
          error: _ctx.errors['name_and_surname']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "nameAndSurname",
              modelValue: _ctx.form.name_and_surname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name_and_surname) = $event)),
              name: "nameAndSurname",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "error"]),
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_GMapAutocomplete, {
            class: _normalizeClass({
            'p-inputtext p-component': !_ctx.addressSearch,
            'p-inputtext p-component p-filled': _ctx.addressSearch,
          }),
            onPlace_changed: _ctx.setAddress,
            options: {
            componentRestrictions: { country: 'si' },
          },
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addressSearch = $event.target.value)),
            value: _ctx.addressSearch,
            placeholder: "",
            id: "address",
            maxlength: "255"
          }, null, 8, ["class", "onPlace_changed", "value"]),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("edit_profile.search")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputTextWrapper, {
            label: _ctx.$t(`forms.application_forum.address`) + '*',
            error: _ctx.errors['address']
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "address",
                modelValue: _ctx.form.address,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.address) = $event)),
                name: "address",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label", "error"]),
          _createVNode(_component_InputTextWrapper, {
            label: _ctx.$t(`forms.application_forum.house_number`) + '*',
            error: _ctx.errors['house_number']
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "addressNumber",
                modelValue: _ctx.form.house_number,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.house_number) = $event)),
                name: "addressNumber",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label", "error"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_InputTextWrapper, {
            label: _ctx.$t(`forms.application_forum.code`) + '*',
            error: _ctx.errors['code']
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "postNumber",
                modelValue: _ctx.form.code,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.code) = $event)),
                name: "postNumber",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label", "error"]),
          _createVNode(_component_InputTextWrapper, {
            label: _ctx.$t(`forms.application_forum.city`) + '*',
            error: _ctx.errors['city']
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputText, {
                id: "city",
                modelValue: _ctx.form.city,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.city) = $event)),
                name: "city"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label", "error"])
        ]),
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.tax_number`) + '*',
          error: _ctx.errors['tax_number']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "taxnNmber",
              modelValue: _ctx.form.tax_number,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.tax_number) = $event)),
              name: "taxnNmber",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "error"]),
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.emso_number`) + '*',
          error: _ctx.errors['emso_number']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "emsoNumber",
              modelValue: _ctx.form.emso_number,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.emso_number) = $event)),
              name: "emsoNumber"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "error"]),
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.registration_number`) + '*'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "registrationNumber",
              modelValue: _ctx.form.registration_number,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.registration_number) = $event)),
              name: "registrationNumber"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.phone_number`) + '*',
          error: _ctx.errors['phone_number']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "phoneNumber",
              modelValue: _ctx.form.phone_number,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.phone_number) = $event)),
              name: "phoneNumber",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "error"]),
        _createVNode(_component_InputTextWrapper, {
          label: _ctx.$t(`forms.application_forum.email`) + '*',
          error: _ctx.errors['email']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.email) = $event)),
              name: "email",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "error"])
      ], 512),
      _createElementVNode("form", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`forms.application_forum.cadastre_and_plot`)), 1),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.errors['cadastral_municipality'])
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.errors["cadastral_municipality"]), 1))
            : _createCommentVNode("", true),
          (_ctx.errors['plot_number'])
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.errors["plot_number"]), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.form.cadastral[0].cadastral_municipality,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.cadastral[0].cadastral_municipality) = $event)),
            options: _ctx.cadastralOptions,
            optionLabel: "name",
            optionValue: "value",
            placeholder: 
            _ctx.$t('forms.application_forum.cadastral_municipality') + '*'
          ,
            style: {"width":"100%"}
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.cadastral, (cadastral, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "plot_numbers"
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_InputTextWrapper, {
                label: _ctx.$t(`forms.application_forum.plot_number`) + '*'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    id: "plotNumber",
                    modelValue: cadastral.plot_number,
                    "onUpdate:modelValue": ($event: any) => ((cadastral.plot_number) = $event),
                    name: "plotNumber",
                    required: "",
                    maxlength: "20"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            (index > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "removeCadastralButton",
                    onClick: ($event: any) => (_ctx.removeCadastral(index)),
                    tabindex: "0",
                    onKeypress: _withKeys(($event: any) => (_ctx.removeCadastral(index)), ["enter"])
                  }, _hoisted_14, 40, _hoisted_12)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.form.cadastral.length < 10)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("span", {
                class: "addCadastralButton",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addCadastral && _ctx.addCadastral(...args))),
                tabindex: "0",
                onKeypress: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addCadastral && _ctx.addCadastral(...args)), ["enter"]))
              }, _hoisted_17, 32)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("text", null, _toDisplayString(_ctx.$t(`forms.application_forum.cadastre_and_plot_description`)), 1)
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`forms.application_forum.location_information_title`)), 1),
        (_ctx.errors['location_information'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.errors["location_information"]), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "location_information_extended",
            value: "location_information_extended",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.location_information) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.form.location_information]
          ]),
          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t(`forms.application_forum.location_information_extended`)), 1)
        ]),
        _createElementVNode("ul", _hoisted_21, [
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_legal_regimes`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "location_information_basic",
            value: "location_information_basic",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.location_information) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.form.location_information]
          ]),
          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t(`forms.application_forum.location_information_basic`)), 1)
        ]),
        _createElementVNode("ul", _hoisted_24, [
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_zoning_acts`)), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_temporary_measures`)), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_preemption_area`)), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_undeveloped_building`)), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_building_development`)), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`forms.application_forum.information_on_consent_area`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            id: "information_of_intented_use_of_space",
            value: "information_of_intented_use_of_space",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.location_information) = $event))
          }, null, 512), [
            [_vModelRadio, _ctx.form.location_information]
          ]),
          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t(`forms.application_forum.information_of_intented_use_of_space`)), 1)
        ])
      ]),
      (
        _ctx.form.location_information === 'location_information_extended' ||
        _ctx.form.location_information === 'location_information_basic'
      )
        ? (_openBlock(), _createElementBlock("form", _hoisted_27, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`forms.application_forum.required_attachment_title`)), 1),
            _createVNode(_component_FormCheckbox, {
              checked: _ctx.form.copy_of_graphic_part,
              "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.copy_of_graphic_part) = $event)),
              label: `forms.application_forum.copy_of_graphic_part`,
              id: "copy_of_graphic_part"
            }, null, 8, ["checked", "label"]),
            _createVNode(_component_FormCheckbox, {
              checked: _ctx.form.spatial_implementation_conditions,
              "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.spatial_implementation_conditions) = $event)),
              label: `forms.application_forum.spatial_implementation_conditions`,
              id: "spatial_implementation_conditions"
            }, null, 8, ["checked", "label"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_Button, {
        "event-name": "nextStepEFormsButton",
        "event-from": "/user/*/new-application",
        class: "defaultButton",
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.nextPage()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("forms.new_form.next")), 1),
          _hoisted_29
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'NewApplications' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("global.cancel")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showFillDialog,
      "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showFillDialog) = $event)),
      class: "successDialog",
      tabindex: "1",
      closable: false,
      draggable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("forms.application_forum.dialog.title")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("forms.application_forum.dialog.description")) + ":", 1),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.name_and_surname")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.email")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
          ]),
          (_ctx.user.phone_number)
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.phone_number")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.phone_number), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.address)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.address")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.address), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.house_number)
            ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.house_number")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.house_number), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.code)
            ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.code")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.code), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.city)
            ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.city")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.city), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("button", {
            class: "defaultButton",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args))),
            tabindex: "1"
          }, _toDisplayString(_ctx.$t("forms.application_forum.dialog.fill_data")), 1),
          _createElementVNode("span", {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showFillDialog = false)),
            tabindex: "1",
            onKeypress: _cache[22] || (_cache[22] = _withKeys(($event: any) => (_ctx.showFillDialog = false), ["enter"]))
          }, _toDisplayString(_ctx.$t("forms.application_forum.dialog.manual")), 33)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}